import { createIcon } from "@chakra-ui/react";

const TrashIcon = createIcon({
  displayName: "TrashIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M8.59861 3.5L7 3.5C6.44772 3.5 6 3.94771 6 4.5V5L9.40139 5L10.4014 3.5L13.5776 3.5L14.7443 5L18 5V4.5C18 3.94771 17.5523 3.5 17 3.5L15.4779 3.5L14.3113 2H9.59861L8.59861 3.5Z"
        fill="currentColor"
      />
      <path
        d="M9.25 17V11H10.75V17H9.25Z"
        fill="currentColor"
      />
      <path
        d="M13.25 11V17H14.75V11H13.25Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.8388 8.5L17.5952 20.1065C17.5408 20.6147 17.1119 21 16.6009 21H7.39806C6.88701 21 6.45819 20.6147 6.40375 20.1065L5.16019 8.5H4V7H20V8.5H18.8388ZM17.3302 8.5L6.66878 8.5L7.84735 19.5H16.1516L17.3302 8.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export default TrashIcon;
